import React from 'react';
import classNames from 'classnames';
import { Icon, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import type { SearchAllContentAvoProjectHit as Type } from '../../../../SearchAllContent/types';
import constructImageSourcesArray from '../../../../../helpers/constructImageSources';
import usePhaseState from '../../../../../helpers/usePhaseState';
import Card from '../../../../Card';

import {
  AVO_PHASE_DURING,

} from '../../../../../config/constants';

import './style.scss';

const MetaSearchAvOProjectHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('MetaSearchHit', 'MetaSearchAvOProjectHit');
  const phase = usePhaseState();
  const ranking = hit.rank?.[0] ?? 0;
  const hasImage = Boolean(hit.image_alt);
  const rankingPrefix = ranking < 20 ? 'de' : 'e';
  const { t } = useTranslation();

  return (
    <Card className={classes}>
      <Card.Content>
        {hasImage && (
          <Card.Image
            image={(
              <Image
                src={constructImageSourcesArray(hit, '3_4')}
                alt={hit.image_alt?.[0]}
                lazyload={false}
              />
            )}
          />
        )}

        <Card.Link href={hit.url[0]}>
          <div className="Card__subtitle-content">
            <Card.Title title={hit.page_title[0]} />
            <Card.Subtitle
              subtitle={(
                <p className="u-truncate--3">
                  {hit.body_summarized?.[0] ? (
                    hit.body_summarized[0]
                  ) : (
                    hit.body?.[0]
                  )}
                </p>
              )}
            />
          </div>
        </Card.Link>

        <div className="Card__wrapper">
          {hit.province && (
            <span className="Card__location">
              <Icon name="location_on" flair="filled" />
              {hit.province[0]}
            </span>
          )}

          <div className="Card__content__body">
            <Card.Title title={hit.page_title[0]} />
          </div>
        </div>

        {phase === AVO_PHASE_DURING ? (
          <a
            href={hit.url[0]}
            className={classNames('Card__content__link', {
              'Card__content__link--no-image': !hasImage,
            })}
            aria-label={t('avo.click_to_detail')}
          >
            <Icon name="arrow_forward" flair="filled" />
          </a>
        ) : (
          <span className="Card__ranking">
            {t('avo.einduitslag')}
            <span className="icon AvOProjectPage-iconInText icon-apple icon-variant-4" />
            {ranking}
            {rankingPrefix}
          </span>
        )}
      </Card.Content>
    </Card>
  );
};

export default MetaSearchAvOProjectHit;
